/*
各種ソーシャルサービスボタンを簡単設置

2016/11/24 ver.2.0.0
	- Webpack対応
*/


exports.set_share_button = function( target ){
	'use strict';

	var window_opt = "width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1";
	var e = encodeURIComponent;

	// クリック動作
	$(document).on('click', target, function(){
		var $this = $(this);
		var url = $this.data('ccl-share-url');
		var msg = $this.data('ccl-share-msg');
		var via = $this.data('ccl-share-via');
		var flw = $this.data('ccl-share-flw');

		if( !url ) url = location.href;
		if( !msg ) msg = document.title;

		switch( $this.data('ccl-share-svc') ){
			case 'twitter':
				twitter(url, msg, via, flw); break;
			case 'facebook':
				facebook(url); break;
			case 'line':
				line(url, msg); break;
			case 'feedly':
				feedly(url); break;
			case 'pocket':
				pocket(url); break;
			case 'hatebu':
				hatebu(url, msg); break;
			case 'google':
				google(url); break;
		}

		return false;
	});

	/***************************
	* Twitter
	*/
	function twitter( url, msg, via, follow ){
		var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';
		if( via ) openURL += '&via=' + e(via);
		if( follow ) openURL += '&related=' + e(follow);
		window.open( openURL, 'tweetwindow', window_opt );
		return false;
	}

	/***************************
	* Facebook
	*/
	function facebook( url ){
		var openURL = 'http://www.facebook.com/share.php?u='+ e(url);
		window.open( openURL, 'facebookwindow', window_opt );
		return false;
	}

	/***************************
	* LINE
	*/
	function line( url, msg ){
		window.location.href = 'line://msg/text/' + e(msg) + ' ' + e(url);
		return false;
	}

	/***************************
	* feedly
	*/
	function feedly( url ){
		var openURL = 'http://feedly.com/i/subscription/feed/' + e(url);
		window.open( openURL, 'feedlywindow', window_opt );
		return false;
	}

	/***************************
	* Pocket
	*/
	function pocket( url ){
		var openURL = 'http://getpocket.com/edit?url=' + e(url);
		window.open( openURL, 'feedlywindow', window_opt );
		return false;
	}

	/***************************
	* はてなブックマーク
	*/
	function hatebu( url, msg ){
		var openURL = '//b.hatena.ne.jp/add?mode=confirm&url=' + e(url) + "&title=" + e(msg);
		window.open( openURL, 'hatebuwindow', window_opt );
		return false;
	}

	/***************************
	* google plus
	*/
	function google( url ){
		var openURL = 'https://plus.google.com/share?url=' + e(url);
		window.open( openURL, 'googlewindow', window_opt );
		return false;
	}

};